/**
 * Plan identity, invoices, billing cycle, and upgrade entry points.
 *
 * Shown by default so production keeps invoice downloads for paying users.
 * Set `VITE_SHOW_PLAN_DETAILS=false` to hide them.
 */
function readShowPlanDetails(): string | undefined {
  // Vite exposes env vars on `import.meta.env`
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SHOW_PLAN_DETAILS != null) {
    // @ts-ignore
    const value = String(import.meta.env.VITE_SHOW_PLAN_DETAILS);
    if (value !== '') return value;
  }
  if (typeof process !== 'undefined' && process.env && process.env.VITE_SHOW_PLAN_DETAILS != null) {
    const value = String(process.env.VITE_SHOW_PLAN_DETAILS);
    if (value !== '') return value;
  }
  return undefined;
}

export const isPlanDetailsVisible = (): boolean => readShowPlanDetails() !== 'false';
